<template>
    <div class="page-table haberTanim  mainDiv" id="affix-container">
        <el-steps :active="active" finish-status="success" :align-center="true"
                  class="card-base card-shadow--medium padding-20 saydamBg">
            <el-step title="Hasta ve Hekim Bilgileri" icon="mdi mdi-account mdi-36px" class="saydamBg"></el-step>
            <el-step title="Cerrahi Uygulama" icon="mdi mdi-tooth mdi-36px"></el-step>
            <el-step title="Randevu Bilgileri" icon="mdi mdi-calendar mdi-36px"></el-step>
            <el-step title="Hasta Özeti" icon="mdi mdi-account mdi-36px"></el-step>
        </el-steps>
        <div v-if="active === 0" class="card-base baslikBg">Hasta Bilgileri</div>
        <div v-if="active === 1" class="card-base baslikBg">Cerrahi Uygulama</div>
        <div v-if="active === 2" class="card-base baslikBg">Randevu Bilgileri</div>
        <div v-if="active === 3" class="card-base baslikBg">Hasta Özeti</div>
        <el-row :gutter="10">
            <el-form label-position="top" status-icon :model="hastaForm" :rules="rulesHasta" ref="hastaForm"
                     class="demo-ruleForm">
                <el-row v-if="active === 0" style="margin-top: 0">
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                        <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                            <el-row>
                                <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='T.C. No : ' prop="tcNo">
                                        <el-input
                                                v-model="hastaForm.tcNo" v-mask="'###########'"
                                                placeholder='T.C. No Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='İsim Soyisim :' prop="adSoyad">
                                        <el-input
                                                v-model="hastaForm.adSoyad"
                                                v-on:input="inputStyle(hastaForm.adSoyad)"
                                                placeholder='İsim Soyisim Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Yaş :' prop="yas">
                                        <el-input
                                                v-model="hastaForm.yas"
                                                v-mask="'##'"
                                                placeholder='Yaş Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='İl :' prop="il">
                                        <el-select
                                                auto-complete="disable"
                                                v-model="hastaForm.il"
                                                filterable
                                                placeholder='İl Seçiniz'
                                                style="width: 100%">
                                            <el-option v-for="item in ilList"
                                                       :key="item.baslik"
                                                       :label="item.baslik"
                                                       :value="item.ilId"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Telefon :' prop="telefon">
                                        <el-input
                                                auto-complete="disable"
                                                v-model="hastaForm.telefon"
                                                v-mask="'+90(###)### ## ##'"
                                                placeholder='Telefon Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='E-Posta :' prop="eposta">
                                        <el-input
                                                type="email"
                                                v-model="hastaForm.eposta"
                                                placeholder='E-Posta Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Cinsiyet :' prop="cinsiyet">
                                        <el-row :gutter="10" style="margin-top: 0">
                                            <el-col :lg="12" :md="12" :sm="12" :xs="24">
                                                <el-radio style="width: 100%; margin-right: 0 !important;"
                                                          v-model="hastaForm.cinsiyet" label="Kadın"
                                                          border
                                                          size="medium">
                                                    <i style="color: deeppink;" class="mdi mdi-human-female"></i> Kadın
                                                </el-radio>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="12" :xs="24" class="mobil-margin">
                                                <el-radio style="width: 100%; margin-left: 0 !important;"
                                                          v-model="hastaForm.cinsiyet" label="Erkek"
                                                          border
                                                          size="medium">
                                                    <i style="color: #337ab7;" class="mdi mdi-human-male"></i> Erkek
                                                </el-radio>
                                            </el-col>
                                        </el-row>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                        <div class="card-base baslikBg " style="margin: 20px 5px 0;">Hekim Bilgileri</div>
                        <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                            <el-row v-for="(itemD,indexD) in hastaForm.doktor" class="margin-top-10  animated fadeInLeft">
                                <el-col :lg="1" :md="1" :sm="24" :xs="24" class="col-p">
                                    <div class="margin-top-30">
                                        <el-button v-on:click="dialogVisibleHekim=true" size="mini" plain
                                                   type="warning" icon="el-icon-plus" class="mobil-doktor-buton">
                                        </el-button>
                                    </div>
                                </el-col>
                                <el-col :lg="7" :md="7" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Hekim Adı : ' prop="doktorId">
                                        <el-select
                                                v-model="itemD.doktorId"
                                                v-on:change="doktorTespit(itemD.doktorId,indexD)"
                                                filterable
                                                placeholder='Hekim Seçiniz'
                                                style="width: 100%">
                                            <el-option v-for="item in hekimList"
                                                       :key="item.hekimId"
                                                       :label="item.adSoyad"
                                                       :value="item.hekimId"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="7" :md="7" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Telefon :' prop="doktorTelefon">
                                        <el-input
                                                :disabled="itemD.doktorId === ''"
                                                v-model="itemD.doktorTelefon" v-mask="'+90(###)### ## ##'"
                                                placeholder='Telefon Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="7" :md="7" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='E-Posta :' prop="doktorEposta">
                                        <el-input
                                                :disabled="itemD.doktorId === ''"
                                                v-model="itemD.doktorEposta"
                                                placeholder='E-Posta Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <!--                                <el-col :lg="5" :md="5" :sm="24" :xs="24" class="col-p">-->
                                <!--                                    <el-form-item label='Klinik :' prop="klinik">-->
                                <!--                                        <el-select-->
                                <!--                                                :disabled="itemD.doktorId === ''"-->
                                <!--                                                v-model="itemD.klinik"-->
                                <!--                                                filterable-->
                                <!--                                                placeholder='Klinik Seçiniz'-->
                                <!--                                                style="width: 100%">-->
                                <!--                                            <el-option v-for="item in klinikList"-->
                                <!--                                                       :key="item.klinikId"-->
                                <!--                                                       :label="item.baslik"-->
                                <!--                                                       :value="item.klinikId"></el-option>-->
                                <!--                                        </el-select>-->
                                <!--                                    </el-form-item>-->
                                <!--                                </el-col>-->
                                <el-col :lg="2" :md="2" :sm="24" :xs="24" class="col-p text-center">
                                    <div class="margin-top-30">
                                        <el-button v-if="indexD+1 === hastaForm.doktor.length" @click="doktorEkle" size="mini" plain
                                                   type="primary" icon="el-icon-plus" class="mobil-doktor-buton">
                                        </el-button>
                                        <el-button v-else @click="removedoktor(indexD)" size="mini" plain
                                                   type="danger" icon="el-icon-minus" class="mobil-doktor-buton">
                                        </el-button>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="active === 1">
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                        <div>
                            <el-row>
                                <div class="animated fadeInUp"
                                     style="display: flex; justify-content: center; margin-top: 50px; margin-bottom: 30px">
                                    <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                                        <div class="tarih-border" style="width: 100%">
                                            <div class="tarih-border-icon">
                                                <i class="el-icon-date"></i>
                                            </div>
                                            <div>
                                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                    <div style="width: 100%;display: flex;justify-content: center">
                                                        <el-form-item prop="cerrahiTarih">
                                                            <el-date-picker
                                                                    v-on:change="tarihChange(hastaForm.cerrahiTarih,'cerrahi')"
                                                                    v-model="hastaForm.cerrahiTarih"
                                                                    type="datetime"
                                                                    :picker-options="dateRangeOptions"
                                                                    format="yyyy-MM-dd HH:mm:ss"
                                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                                    placeholder="Cerrahi Uygulama Tarihi"
                                                                    default-time="12:00:00">
                                                            </el-date-picker>
                                                        </el-form-item>
                                                    </div>
                                                </el-col>
                                            </div>
                                        </div>
                                    </el-col>
                                </div>
                            </el-row>
                            <el-row v-if="hastaForm.cerrahiTarih !== ''">
                                <el-col :xl="6" :lg="8" :md="10" :sm="24" :xs="24" class="col-p" aria-disabled="true">
                                    <div class="card-base card-shadow--medium margin-top-20 demo-box bg-white animated fadeInLeft"
                                         style="position: relative">
                                        <el-form-item
                                                style="position: relative"
                                                prop="disId'">
                                            <dis-s-v-g :ceruygulama="hastaForm.cerrahiUygList"></dis-s-v-g>
                                            <div v-if="disId !==''" class="animated fadeIn gharipDis"></div>
                                            <span v-if="disId !==''" class="animated fadeIn gharipDisYazi">{{disId}}</span>
                                            <el-button v-if="disId !==''" size="mini" class="disIptalButon" @click="disIptal(disId)">
                                                İptal
                                            </el-button>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :xl="18" :lg="16" :md="14" :sm="24"
                                        :xs="24" class="col-p">
                                    <div class="card-base card-shadow--medium margin-top-20 demo-box bg-white animated fadeInLeft dis-sol">
                                        <div class="dis-sol-input">
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item label='Ürün: '
                                                              prop="urunId">
                                                    <el-select
                                                            v-on:change="disOnayKaydet(disId)"
                                                            :disabled="rightDisable"
                                                            v-model="urunId"
                                                            placeholder='Ürün Seçiniz'
                                                            filterable
                                                            style="width: 100%">
                                                        <el-option v-for="item in urunList"
                                                                   :key="item.baslik"
                                                                   :label="item.baslik"
                                                                   :value="item.urunId"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item label='Ürün Lot: '
                                                              prop="urunLot">
                                                    <el-input
                                                            v-on:change="disOnayKaydet(disId)"
                                                            :disabled="rightDisable"
                                                            @input="urunLot=urunLot.toUpperCase()"
                                                            v-model="urunLot"
                                                            placeholder='Ürün Lot Giriniz'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item label='Ek Ürün: '
                                                              prop="ekUrunId">
                                                    <el-select
                                                            v-on:change="disOnayKaydet(disId)"
                                                            :disabled="rightDisable"
                                                            filterable
                                                            v-model="ekUrunId"
                                                            placeholder='Ek Ürün Seçiniz'
                                                            style="width: 100%">
                                                        <el-option v-for="item in ekUrunList"
                                                                   :key="item.ekurunId"
                                                                   :label="item.baslik"
                                                                   :value="item.ekurunId"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item label='Ek Ürün Lot: '
                                                              prop="ekUrunLot">
                                                    <el-input
                                                            v-on:change="disOnayKaydet(disId)"
                                                            :disabled="rightDisable"
                                                            @input="ekUrunLot=ekUrunLot.toUpperCase()"
                                                            v-model="ekUrunLot"
                                                            placeholder='Ürün Lot Giriniz'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item label='Ek Tedavi: '
                                                              prop="ekTedaviId">
                                                    <el-select
                                                            v-on:change="disOnayKaydet(disId)"
                                                            :disabled="rightDisable"
                                                            filterable
                                                            v-model="ekTedaviId"
                                                            placeholder='Ek Tedavi Seçiniz'
                                                            style="width: 100%">
                                                        <el-option v-for="item in ekTedaviList"
                                                                   :key="item.ektedaviId"
                                                                   :label="item.baslik"
                                                                   :value="item.ektedaviId"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item label='ISQ: ' prop="isq">
                                                    <el-input
                                                            v-on:change="disOnayKaydet(disId)"
                                                            :disabled="rightDisable"
                                                            v-mask="'####################'"
                                                            v-model="isq"
                                                            placeholder='ISQ Giriniz'></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="active === 2">
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                        <div>
                            <el-row>
                                <div class="animated fadeInUp"
                                     style="display: flex; justify-content: center; margin-top: 50px; margin-bottom: 30px">
                                    <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                                        <div class="tarih-border" style="width: 100%; padding-bottom: 20px !important;">
                                            <div class="tarih-border-icon">
                                                <i class="el-icon-date"></i>
                                            </div>
                                            <div style="overflow:hidden;">
                                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p" style="margin-top: 5px !important;">
                                                    <div style="width: 100%;display: flex;justify-content: center">
                                                        <el-form-item label='Hekim: '
                                                                      prop="randevuHekim">
                                                            <el-select
                                                                    filterable
                                                                    v-model="hastaForm.randevuHekim"
                                                                    placeholder='Hekim Seçiniz'
                                                                    style="width: 100%">
                                                                <el-option v-for="item in hastaForm.doktor"
                                                                           :key="item.doktorId"
                                                                           :label="hekimAdii(item.doktorId)"
                                                                           :value="item.doktorId"></el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                    </div>
                                                </el-col>

                                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p" style="margin-top: 5px !important;">
                                                    <div style="width: 100%;display: flex;justify-content: center">
                                                        <el-form-item prop="randevuTarihi">
                                                            <el-date-picker
                                                                    v-on:change="tarihChange(hastaForm.randevuTarihi,'randevu')"
                                                                    v-model="hastaForm.randevuTarihi"
                                                                    type="datetime"
                                                                    :picker-options="dateRangeOptions"
                                                                    format="yyyy-MM-dd HH:mm:ss"
                                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                                    placeholder="Randevu Tarihi"
                                                                    default-time="12:00:00">
                                                            </el-date-picker>
                                                        </el-form-item>
                                                    </div>
                                                </el-col>
                                            </div>
                                        </div>
                                    </el-col>
                                </div>
                            </el-row>
                            <div v-if="hastaForm.randevuTarihi !== ''">
                                <el-col :xl="6" :lg="8" :md="10" :sm="24" :xs="24" class="col-p" aria-disabled="true">
                                    <div class="card-base card-shadow--medium margin-top-20 demo-box bg-white animated fadeInLeft"
                                         style="position: relative">
                                        <el-form-item
                                                style="position: relative"
                                                prop="disId'">
                                            <dis-s-v-g-ran :ceruygulama="hastaForm.cerrahiUygList" :randevu="hastaForm.randevuList"></dis-s-v-g-ran>
                                            <div v-if="disIdRan !==''" class="animated fadeIn gharipDis"></div>
                                            <span v-if="disIdRan !==''" class="animated fadeIn gharipDisYazi">{{disIdRan}}</span>
                                            <el-button v-if="disIdRan !==''" size="mini" class="disIptalButon" @click="disIptalRan(disIdRan)">
                                                İptal
                                            </el-button>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :xl="18" :lg="16" :md="14" :sm="24"
                                        :xs="24" class="col-p">
                                    <div class="card-base card-shadow--medium margin-top-20 demo-box bg-white animated fadeInLeft dis-sol">
                                        <el-col :span="24" class="col-p" style="padding: 70px 0;">
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item label='Planlanan Uygulama: '
                                                              prop="ekTedaviIdRan">
                                                    <el-select
                                                            v-on:change="disOnayKaydetRan(disIdRan);getEkUrunlerList()"
                                                            :disabled="rightDisableRan"
                                                            filterable
                                                            v-model="ekTedaviIdRan"
                                                            placeholder='Ek Tedavi Seçiniz'
                                                            style="width: 100%">
                                                        <el-option v-for="item in ekTedaviList"
                                                                   :key="item.ektedaviId"
                                                                   :label="item.baslik"
                                                                   :value="item.ektedaviId"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item label='Protetik Ürün: ' prop="ekUrunIdRan">
                                                    <el-select
                                                            v-on:change="disOnayKaydetRan(disIdRan)"
                                                            :disabled="rightDisableRan"
                                                            filterable
                                                            v-model="ekUrunIdRan"
                                                            placeholder='Ek Ürün Seçiniz'
                                                            style="width: 100%">
                                                        <el-option v-for="item in ekUrunList"
                                                                   :key="item.ekurunId"
                                                                   :label="item.baslik"
                                                                   :value="item.ekurunId"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item label='Lot: ' prop="ekUrunLotRan">
                                                    <el-input
                                                            v-on:change="disOnayKaydetRan(disIdRan)"
                                                            :disabled="rightDisableRan"
                                                            @input="ekUrunLotRan=ekUrunLotRan.toUpperCase()"
                                                            v-model="ekUrunLotRan"
                                                            placeholder='Lot Giriniz'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item label='ISQ: ' prop="isqRan">
                                                    <el-input
                                                            v-on:change="disOnayKaydetRan(disIdRan)"
                                                            :disabled="rightDisableRan"
                                                            v-mask="'####################'"
                                                            v-model="isqRan"
                                                            placeholder='ISQ Giriniz'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item label='Açıklama: ' prop="aciklamaRan">
                                                    <el-input
                                                            v-on:change="disOnayKaydetRan(disIdRan)"
                                                            :disabled="rightDisableRan"
                                                            v-model="aciklamaRan"
                                                            placeholder='Açıklama'></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-col>
                                    </div>
                                </el-col>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="active===3">
                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="margin-top-80 col-p">
                        <div class="hastaKabulBaslikSerit animated fadeInUp">
                            <div class="hastaKabulBaslik">
                                <h1>HASTA KABUL VE İLETİŞİM FORMU</h1>
                            </div>
                        </div>
                        <el-row class="ozel-row animated fadeInUp">

                            <el-col :lg="8" :md="8" :sm="24" :xs="24">
                                                            <div class="formBilgileri">
                                                                <div class="formBilgiBaslik">Hekim Bilgileri</div>
                                                                <div class="mobil-baslik">Hekim Bilgileri</div>
                                                                <div class="formElemanlari">
                                                                    <div class="doktor-bilgi">
                                                                        <div class="input-effect">
                                                                            <div class="formBilgi">Adı Soyadı:</div>
                                                                            <div class="effect-7 yazdir-bilgisi">
                                                                                {{hekimAdii(hastaForm.doktor[0].doktorId)}}
                                                                            </div>
                                                                        </div>
                                                                        <div class="input-effect">
                                                                            <div class="formBilgi">Telefon:</div>
                                                                            <div class="effect-7 yazdir-bilgisi">{{hastaForm.doktor[0].doktorTelefon}}</div>
                                                                        </div>
                                                                        <div class="input-effect">
                                                                            <div class="formBilgi">E-Mail:</div>
                                                                            <div class="effect-7 yazdir-bilgisi">{{hastaForm.doktor[0].doktorEposta}}</div>
                                                                        </div>
                                                                        <div class="input-effect">
                                                                            <div class="formBilgi">Klinik:</div>
                                                                            <div class="effect-7 yazdir-bilgisi">{{klinikName(hastaForm.klinik)}}
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </el-col>
                            <el-col :lg="8" :md="8" :sm="24" :xs="24">
                                                            <div class="formBilgileri">
                                                                <div class="formBilgiBaslik">Protez Bilgileri</div>
                                                                <div class="mobil-baslik">Protez Bilgileri</div>
                                                                <div class="formElemanlari">
                                                                    <div class="doktor-bilgi">
                                                                        <div class="input-effect">
                                                                            <div class="formBilgi">Adı Soyadı:</div>
                                                                            <div class="effect-7 yazdir-bilgisi">
                                                                                {{hekimAdii(hastaForm.doktor[1].doktorId)}}
                                                                            </div>
                                                                        </div>
                                                                        <div class="input-effect">
                                                                            <div class="formBilgi">Telefon:</div>
                                                                            <div class="effect-7 yazdir-bilgisi">{{hastaForm.doktor[1].doktorTelefon}}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </el-col>
                            <el-col :lg="8" :md="8" :sm="24" :xs="24">
                                <div id="hastaBilgileri" class="formBilgileri ozel-sagayasla">
                                    <div class="mobil-baslik">Hasta Bilgileri</div>
                                    <div class="formElemanlari">
                                        <div class="doktor-bilgi">
                                            <div class="input-effect">
                                                <div class="formBilgi">T.C.:</div>
                                                <div class="effect-7 yazdir-bilgisi">{{hastaForm.tcNo}}</div>
                                            </div>
                                            <div class="input-effect">
                                                <div class="formBilgi">Adı Soyadı:</div>
                                                <div class="effect-7 yazdir-bilgisi">{{hastaForm.adSoyad}}</div>
                                            </div>
                                            <div class="input-effect">
                                                <div class="formBilgi">Yaş / Cinsiyet:</div>
                                                <div class="effect-7 yazdir-bilgisi">{{hastaForm.yas}} /
                                                    {{hastaForm.cinsiyet}}
                                                </div>
                                            </div>
                                            <div class="input-effect">
                                                <div class="formBilgi">İl:</div>
                                                <div class="effect-7 yazdir-bilgisi">{{ilAdi(hastaForm.il)}}</div>
                                            </div>
                                            <div class="input-effect">
                                                <div class="formBilgi">Telefon:</div>
                                                <div class="effect-7 yazdir-bilgisi">{{hastaForm.telefon}}</div>
                                            </div>
                                            <div v-if="hastaForm.eposta !== ''" class="input-effect">
                                                <div class="formBilgi">E-Mail:</div>
                                                <div class="effect-7 yazdir-bilgisi">{{hastaForm.eposta}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="formBilgiBaslik sagTaraf">Hasta Bilgileri</div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="animated fadeInUp" style="display: flex; justify-content: center">
                            <el-col :lg="16" :md="16" :sm="24" :xs="24">
                                <div class="grupBilgisi margin-top-20">
                                    <p>Cerrahi Uygulama</p>
                                </div>
                                <div class="disOpsiyonlari" v-for="(item,index) in hastaForm.cerrahiUygList">
                                    <div class="opsiyonDiv disNumarasi-yazdir">
                                        <div>Diş Numarası</div>
                                        <div><span>{{item['disId']}}</span></div>
                                    </div>
                                    <div class="opsiyonDiv">
                                        <div>Tarih:</div>
                                        <div>{{dateCerrahi}}</div>
                                    </div>
                                    <div class="opsiyonDiv">
                                        <div>Ürün Adı:</div>
                                        <div>{{urunAdi(item['urunId'])}}</div>
                                    </div>
                                    <div class="opsiyonDiv">
                                        <div>Ürün Lot:</div>
                                        <div>{{item['urunLot']}}</div>
                                    </div>
                                    <div v-if="item['ekUrunId'] !==''" class="opsiyonDiv">
                                        <div>Ek Ürün Adı:</div>
                                        <div>{{ekUrunAdi(item['ekUrunId'])}}</div>
                                    </div>
                                    <div v-if="item['ekUrunLot'] !==''" class="opsiyonDiv">
                                        <div>Ek Ürün Lot:</div>
                                        <div>{{item['ekUrunLot']}}</div>
                                    </div>
                                    <div v-if="item['ekTedaviId'] !==''" class="opsiyonDiv">
                                        <div>Ek Tedavi:</div>
                                        <div>{{ekTedaviAdi(item['ekTedaviId'])}}</div>
                                    </div>
                                    <div v-if="item['isq']!==''" class="opsiyonDiv">
                                        <div>ISQ:</div>
                                        <div>{{item['isq']}}</div>
                                    </div>
                                    <div v-if="index < hastaForm.cerrahiUygList.length - 1"
                                         class="disler-arasi-cizgi"></div>
                                </div>
                                <div class="grupBilgisi" v-if="hastaForm.randevuTarihi !== ''">
                                    <p>Randevu Bilgileri</p>
                                </div>
                                <div class="disOpsiyonlari randevular" v-if="hastaForm.randevuTarihi !== ''"
                                     v-for="(item,index) in hastaForm.randevuList">
                                    <div class="opsiyonDiv">
                                        <div>Randevu Tarihi:</div>
                                        <div>{{hastaForm.randevuTarihi}}</div>
                                    </div>
                                    <div v-if="item['ekTedaviId'] !== ''" class="opsiyonDiv">
                                        <div>Planlanan Uygulama:</div>
                                        <div>{{ekTedaviAdi(item['ekTedaviId'])}}</div>
                                    </div>
                                    <div v-if="item['ekUrunId'] !== ''" class="opsiyonDiv">
                                        <div>Protetik Ürün:</div>
                                        <div>{{ekUrunAdi(item['ekUrunId'])}}</div>
                                    </div>
                                    <div v-if="item['ekUrunLot'] !== ''" class="opsiyonDiv">
                                        <div>Lot:</div>
                                        <div>{{item['ekUrunLot']}}</div>
                                    </div>
                                    <div v-if="item['isq']!==''" class="opsiyonDiv">
                                        <div>ISQ:</div>
                                        <div>{{item['isq']}}</div>
                                    </div>
                                    <div v-if="index < hastaForm.randevuList.length - 1"
                                         class="disler-arasi-cizgi"></div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row v-if="active===4">
                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="margin-top-80">
                        <div class="esnek-kutu">
                            <div class="randevuTamamlama text-center">
                                <div class="randevuTamamlamaIcon">
                                    <i class="el-icon-check"></i>
                                </div>
                                Randevunuz<br>Tamamlanmıştır!
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-col :span="24">
                    <el-button v-if="active !==0 && active!==4" class="estas-buton geriButton" size="small"
                               type="primary"
                               style="float: left;margin-top: 15px;"
                               @click="back">
                        <svg width="14.3" height="15.4" xmlns="http://www.w3.org/2000/svg"
                             style="transform: rotate(180deg); margin-right: 8px">
                            <g>
                                <rect fill="none" id="canvas_background" height="17.4" width="16.3" y="-1" x="-1"/>
                                <g display="none" overflow="visible" y="0" x="0" height="100%" width="100%"
                                   id="canvasGrid">
                                    <rect fill="url(#gridpattern)" stroke-width="0" y="0" x="0" height="100%"
                                          width="100%"/>
                                </g>
                            </g>
                            <g>
                                <g id="svg_6">
                                    <line stroke="#fff" stroke-linecap="undefined" stroke-linejoin="undefined"
                                          id="svg_1" y2="8.69427" x2="13.35044" y1="0.93082" x1="5.58699"
                                          stroke-width="2.5" fill="none"/>
                                    <line stroke="#fff" transform="rotate(90 9.593730926513672,10.687480926513674) "
                                          stroke-linecap="undefined" stroke-linejoin="undefined" id="svg_2" y2="14.4442"
                                          x2="13.35044" y1="6.93075" x1="5.83699" stroke-width="2.5" fill="none"/>
                                    <line stroke-linecap="undefined" stroke-linejoin="undefined" id="svg_3" y2="8.49066"
                                          x2="5.70942" y1="3.55579" x1="0.77455" fill-opacity="null"
                                          stroke-opacity="null" stroke-width="2" stroke="#fff" fill="none"/>
                                    <line transform="rotate(90 3.241995811462401,9.58568859100342) "
                                          stroke-linecap="undefined" stroke-linejoin="undefined" id="svg_4"
                                          y2="12.05312" x2="5.70942" y1="7.11825" x1="0.77455" fill-opacity="null"
                                          stroke-opacity="null" stroke-width="2" stroke="#fff" fill="none"/>
                                </g>
                            </g>
                        </svg>
                        Geri
                    </el-button>
                    <el-button class="margin-bottom-50 estas-buton ileriButton" v-if="active!==3 && active!==4"
                               size="small"
                               type="primary"
                               style="float: right;margin-top: 15px;"
                               @click="next">
                        İleri
                        <svg width="14.3" height="15.4" xmlns="http://www.w3.org/2000/svg" style="margin-left: 8px">
                            <g>
                                <rect fill="none" id="canvas_background" height="17.4" width="16.3" y="-1" x="-1"/>
                                <g display="none" overflow="visible" y="0" x="0" height="100%" width="100%"
                                   id="canvasGrid">
                                    <rect fill="url(#gridpattern)" stroke-width="0" y="0" x="0" height="100%"
                                          width="100%"/>
                                </g>
                            </g>
                            <g>
                                <g id="svg_6">
                                    <line stroke="#fff" stroke-linecap="undefined" stroke-linejoin="undefined"
                                          id="svg_1" y2="8.69427" x2="13.35044" y1="0.93082" x1="5.58699"
                                          stroke-width="2.5" fill="none"/>
                                    <line stroke="#fff" transform="rotate(90 9.593730926513672,10.687480926513674) "
                                          stroke-linecap="undefined" stroke-linejoin="undefined" id="svg_2" y2="14.4442"
                                          x2="13.35044" y1="6.93075" x1="5.83699" stroke-width="2.5" fill="none"/>
                                    <line stroke-linecap="undefined" stroke-linejoin="undefined" id="svg_3" y2="8.49066"
                                          x2="5.70942" y1="3.55579" x1="0.77455" fill-opacity="null"
                                          stroke-opacity="null" stroke-width="2" stroke="#fff" fill="none"/>
                                    <line transform="rotate(90 3.241995811462401,9.58568859100342) "
                                          stroke-linecap="undefined" stroke-linejoin="undefined" id="svg_4"
                                          y2="12.05312" x2="5.70942" y1="7.11825" x1="0.77455" fill-opacity="null"
                                          stroke-opacity="null" stroke-width="2" stroke="#fff" fill="none"/>
                                </g>
                            </g>
                        </svg>
                    </el-button>
                    <el-button class="margin-bottom-50 estas-buton ileriButton" v-if="active ===3" size="small"
                               type="primary"
                               style="float: right;margin-top: 15px;"
                               @click="hastaTanimlama">
                        Kaydet
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                            <path fill="#fff" d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"/>
                        </svg>
                    </el-button>
                </el-col>
            </el-form>
        </el-row>
        <el-dialog
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                title='Klinik Listesi'
                :visible.sync="klinikDialogVisible"
                append-to-body
                width="40%"
                class="klinikModal"
                center>
            <span>
                <el-row>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">

                        <el-select
                                auto-complete="disable"
                                v-model="hastaForm.klinik"
                                filterable
                                placeholder='Klinik Seçiniz'
                                style="width: 100%">
                                            <el-option v-for="item in doktorlarKlinikList"
                                                       :key="item.baslik"
                                                       :label="item.baslik"
                                                       :value="item.klinikId"></el-option>
                                        </el-select>

                    </el-col>
                </el-row>
            </span>

            <span slot="footer" class="dialog-footer">
                <el-button class="margin-bottom-50 estas-buton ileriButton"
                           size="small"
                           type="primary"
                           style="margin:0"
                           @click="klinikKontrol">
                        Kaydet
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                            <path fill="#fff" d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"/>
                        </svg>
                    </el-button>
                </span>


        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                title='KVKK Onay'
                :visible.sync="dogrulamaKoduTelefonVisible"
                append-to-body
                width="40%"
                class="klinikModal"
                center>
            <span>
                <el-row>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                         <el-radio v-model="radioTur" label="0">Onay Al</el-radio>
                        <el-radio v-model="radioTur" label="1">Onay Alınmış Hasta Seç</el-radio>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col v-if="radioTur === '0'" :lg="24" :md="24" :sm="24" :xs="24" class="margin-top-10">
                        <el-input
                                v-mask="'+90(###)### ## ##'"
                                v-model="telefonNo"
                                placeholder='Telefon Numarası Giriniz'
                                style="width: 100%"></el-input>
                    </el-col>
                    <el-col v-if="radioTur === '1'" :lg="24" :md="24" :sm="24" :xs="24" class="margin-top-10">
                        <el-select
                                v-model="telefonNo"
                                filterable
                                placeholder='Telefon No Seçiniz'
                                style="width: 100%">
                                            <el-option v-for="item in kaydedilmeyenHasta"
                                                       :key="item.telefon"
                                                       :label="item.telefon"
                                                       :value="item.telefon"></el-option>
                                        </el-select>
                    </el-col>
                </el-row>
            </span>

            <span slot="footer" class="dialog-footer">
                <el-button v-if="radioTur === '0'" class="margin-bottom-50 estas-buton ileriButton"
                           size="small"
                           type="primary"
                           style="margin:0"
                           @click="kodGonder">
                        Kod Gönder
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                            <path fill="#fff" d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"/>
                        </svg>
                </el-button>&nbsp;
                <el-button v-if="radioTur === '1'" class="margin-bottom-50 estas-buton ileriButton"
                           size="small"
                           type="primary"
                           style="margin:0"
                           @click="dogrulamaDevamEt">
                        Devam Et
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                            <path fill="#fff" d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"/>
                        </svg>
                </el-button>&nbsp;
                <el-button
                        size="small"
                        type="primary"
                        style="margin:0"
                        @click="iptal">
                        İptal
                </el-button>
            </span>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                title='KVKK Onay Kontrol'
                :visible.sync="dogrulamaKoduVisible"
                append-to-body
                width="40%"
                class="klinikModal"
                center>
            <span>
                <el-row>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                        <el-input
                                v-model="dogrulamaKodu"
                                filterable
                                placeholder='Doğrulama Kodu Giriniz'
                                style="width: 100%"></el-input>
                    </el-col>
                </el-row>
            </span>

            <span slot="footer" class="dialog-footer">
                <el-button class="margin-bottom-50 estas-buton ileriButton"
                           size="small"
                           type="primary"
                           style="margin:0"
                           @click="dogrulamaKontrol">
                        Doğrula ve Kaydet
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                            <path fill="#fff" d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"/>
                        </svg>
                </el-button>
            </span>
        </el-dialog>
        <!--<el-dialog-->

        <!--title='Uyarı'-->
        <!--:visible.sync="disOnay"-->
        <!--append-to-body-->
        <!--width="40%"-->
        <!--class="klinikModal"-->
        <!--center>-->
        <!--<span>-->
        <!--{{eskiDisId}} numaralı diş üzerinde yapılan değişiklikleri kaydetmek ister misiniz?-->
        <!--</span>-->

        <!--<span slot="footer" class="dialog-footer">-->
        <!--<el-button class="margin-bottom-50 estas-buton ileriButton"-->
        <!--size="small"-->
        <!--type="primary"-->
        <!--style="margin:0"-->
        <!--@click="disOnayKaydet(); disOnay=false">-->
        <!--Kaydet-->
        <!--</el-button>-->
        <!--</span>-->
        <!--</el-dialog>-->
        <hekim-tanimlama v-if="dialogVisibleHekim" :dialogvisible.sync="dialogVisibleHekim"></hekim-tanimlama>
    </div>

</template>

<script>
    import DisSVG from '@/components/DisSVG'
    import DisSVGRan from '@/components/DisSVGRan'
    import HekimTanimlama from '@/components/HekimTanimlama'
    import EventBus from '@/components/event-bus'
    import yoneticiService from '../../../WSProvider/YoneticiService'
    import ilService from '../../../WSProvider/IlService'
    import cerrahiService from '../../../WSProvider/CerrahiService'
    import hekimService from '../../../WSProvider/HekimService'
    import kvkkService from '../../../WSProvider/KvkkService'
    import hastaService from '../../../WSProvider/HastaService'
    import notification from '../../../notification'
    import functions from '../../../functions'
    import JQuery from 'jquery';

    var base64 = require('base64_js');

    let $ = JQuery;
    export default {
        name: "HastaTanimlama",
        components: {
            DisSVG, HekimTanimlama, DisSVGRan
        },
        // watch: {
        //     cerrahiTarih: function (val) {
        //         console.log(val)
        //         this.dateCerrahi = functions.dateconvert(val)
        //     }
        // },
        data() {
            return {
                radioTur  : '0',
                telefonNo: '',
                dogrulamaKodu: '',
                disId: '',
                disIdRan: '',
                eskiDisId: '',
                urunId: '',
                urunLot: '',
                ekUrunId: '',
                ekUrunIdRan: '',
                ekUrunLot: '',
                ekUrunLotRan: '',
                ekTedaviId: '',
                ekTedaviIdRan: '',
                isq: '',
                isqRan: '',
                aciklamaRan: '',
                rightDisable: true,
                rightDisableRan: true,


                dogrulamaKoduTelefonVisible: true,
                dogrulamaKoduVisible: false,
                klinikDialogVisible: false,
                dateCerrahi: '',
                dateRandevu: '',
                secilenDis: '',
                dialogVisibleHekim: false,
                active: 0,
                ilList: [],
                // klinikList: [],
                klinikHekimList: [],
                doktorlarKlinikList: [],
                doktorList: [],
                urunList: [],
                ekUrunList: [],
                ekTedaviList: [],
                ekTedaviListKlon: [],
                hekimList: [],
                cerrahiUygList: [{
                    disId: '',
                    urunId: '',
                    urunLot: '',
                    ekUrunId: '',
                    ekUrunLot: '',
                    isq: '',
                    ekTedaviId: '',
                }],

                kaydedilmeyenHasta: [],
                hastaList: [],
                dateRangeOptions: {
                    firstDayOfWeek: 1,
                },
                hastaForm: {
                    tcNo: '',
                    adSoyad: '',
                    yas: '',
                    cinsiyet: '',
                    telefon: '',
                    eposta: '',
                    il: '',
                    randevuHekim: '',

                    doktor: [{
                        doktorId: '',
                        doktorTelefon: '',
                        doktorEposta: '',
                    }],
                    klinik: '',

                    cerrahiTarih: '',
                    cerrahiUygList: [],


                    randevuTarihi: '',
                    randevuList: [],

                },
                rulesHasta: {
                    tcNo: [{
                        required: true,
                        message: "Lütfen T.C. No Giriniz",
                        trigger: 'blur'
                    }],
                    adSoyad: [{
                        required: true,
                        message: "Lütfen İsim Soyisim Giriniz.",
                        trigger: 'change'
                    }],
                    yas: [{
                        required: true,
                        message: "Lütfen Yaş Seçiniz.",
                        trigger: 'change'
                    }],
                    cinsiyet: [{
                        required: true,
                        message: "Lütfen Cinsiyet Seçiniz.",
                        trigger: 'change'
                    }],
                    telefon: [{
                        required: true,
                        message: "Lütfen Telefon Seçiniz.",
                        trigger: 'change'
                    }],
                    il: [{
                        required: true,
                        message: "Lütfen İl Seçiniz.",
                        trigger: 'change'
                    }],
                    // doktorId: [{
                    //     required: true,
                    //     message: "Lütfen Hekim Seçiniz.",
                    //     trigger: 'change'
                    // }],
                    // doktorTelefon: [{
                    //     required: true,
                    //     message: "Lütfen Telefon Giriniz.",
                    //     trigger: 'change'
                    // }],
                    // doktorEposta: [{
                    //     required: true,
                    //     message: "Lütfen E-Posta Giriniz.",
                    //     trigger: 'change'
                    // }],
                    // klinik: [{
                    //     required: true,
                    //     message: "Lütfen Klinik Seçiniz.",
                    //     trigger: 'change'
                    // }],
                    cerrahiTarih: [{
                        required: true,
                        message: "Lütfen Cerrahi Tarihi Seçiniz.",
                        trigger: 'change'
                    }],
                },
            }
        },
        created(){
          kvkkService.kvkkTamamlanmamis().then((response) => {
              if(response.status === 200){
                  this.kaydedilmeyenHasta = response.data
              }
          })
        },
        mounted() {
            let self = this;
            if (localStorage.getItem("userData3H")) {
                var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
                if (userData3H["tur"]) {
                    if (userData3H["tur"] === '1') {
                        this.getIl();
                    } else if (userData3H["tur"] === '2') {
                        this.getIl();
                    } else if (userData3H["tur"] === '3') {
                        this.getIlYonetici();
                    } else if (userData3H["tur"] === '4') {
                        this.getIlYonetici();
                    } else if (userData3H["tur"] === '5') {
                        this.getIlYonetici();
                    }
                }

            }

            this.getUrunList();
            this.getEkUrunList();
            this.getEkTedaviList();
            this.getHekimList();


            EventBus.$on('hekimList', function (bool) {
                if (bool) {
                    self.getHekimList();
                }
            });
            EventBus.$on('deneme', function (disId) {
                if (disId) {
                    self.rightDisable = false;
                    if (self.disId !== '') {
                        self.disOnayKaydet(self.disId)
                    }
                    self.disId = disId;
                    var obj = self.hastaForm.cerrahiUygList.find(data => data.disId === disId)
                    if (obj) {
                        self.urunId = obj.urunId;
                        self.urunLot = obj.urunLot;
                        self.ekUrunId = obj.ekUrunId;
                        self.ekUrunLot = obj.ekUrunLot;
                        self.isq = obj.isq;
                        self.ekTedaviId = obj.ekTedaviId;
                    } else {
                        self.urunId = '';
                        self.urunLot = '';
                        self.ekUrunId = '';
                        self.ekUrunLot = '';
                        self.isq = '';
                        self.ekTedaviId = '';
                    }
                }
            });
            EventBus.$on('denemeRan', function (disId) {
                if (disId) {
                    self.rightDisableRan = false;
                    if (self.disIdRan !== '') {
                        self.disOnayKaydetRan(self.disIdRan)
                    }
                    self.disIdRan = disId;
                    var obj = self.hastaForm.randevuList.find(data => data.disId === disId)
                    if (obj) {
                        self.ekUrunIdRan = obj.ekUrunId;
                        self.ekUrunLotRan = obj.ekUrunLot;
                        self.isqRan = obj.isq;
                        self.aciklamaRan = obj.aciklama;
                        self.ekTedaviIdRan = obj.ekTedaviId;
                    } else {
                        self.ekUrunIdRan = '';
                        self.ekUrunLotRan = '';
                        self.isqRan = '';
                        self.aciklamaRan = '';
                        self.ekTedaviIdRan = '';
                    }
                }
            });
        },
        methods: {
            disOnayKaydet(disId) {
                let self = this;
                var obj = self.hastaForm.cerrahiUygList.find(data => data.disId === disId)
                if (obj === undefined) {
                    self.hastaForm.cerrahiUygList.push({
                        disId: disId,
                        urunId: self.urunId,
                        urunLot: self.urunLot,
                        ekUrunId: self.ekUrunId,
                        ekUrunLot: self.ekUrunLot,
                        isq: self.isq,
                        ekTedaviId: self.ekTedaviId,
                    });
                } else {
                    obj.urunId = self.urunId;
                    obj.urunLot = self.urunLot;
                    obj.ekUrunId = self.ekUrunId;
                    obj.ekUrunLot = self.ekUrunLot;
                    obj.isq = self.isq;
                    obj.ekTedaviId = self.ekTedaviId;
                }


            },
            disOnayKaydetRan(disId) {
                let self = this;
                var obj = self.hastaForm.randevuList.find(data => data.disId === disId)
                if (obj === undefined) {
                    self.hastaForm.randevuList.push({
                        disId: disId,
                        ekUrunId: self.ekUrunIdRan,
                        ekUrunLot: self.ekUrunLotRan,
                        isq: self.isqRan,
                        aciklama: self.aciklamaRan,
                        ekTedaviId: self.ekTedaviIdRan,
                    });
                } else {
                    obj.ekUrunId = self.ekUrunIdRan;
                    obj.ekUrunLot = self.ekUrunLotRan;
                    obj.isq = self.isqRan;
                    obj.aciklama = self.aciklamaRan;
                    obj.ekTedaviId = self.ekTedaviIdRan;
                }


            },
            klinikKontrol() {
                if (this.hastaForm.klinik !== '') {
                    this.klinikDialogVisible = false
                } else
                    notification.Status('warning', this, 'Lütfen klinik seçin.');
            },
            getEkUrunlerList(disIdRan) {
                cerrahiService.tedaviEkUrunListesi(1, "", "", this.ekTedaviIdRan).then((response) => {
                    if (response.status === 200) {
                        this.ekUrunList = response.data
                    } else notification.Status(response.status, this)
                })

            },
            disIptal(disId) {
                this.disId = '';
                var obj = this.hastaForm.cerrahiUygList.find(data => data.disId === disId);
                this.hastaForm.cerrahiUygList.splice(this.hastaForm.cerrahiUygList.indexOf(obj), 1);
                EventBus.$emit("disList", true)
            },
            disIptalRan(disId) {
                this.disIdRan = '';
                var obj = this.hastaForm.randevuList.find(data => data.disId === disId);
                this.hastaForm.randevuList.splice(this.hastaForm.randevuList.indexOf(obj), 1);
                EventBus.$emit("disListRan", true)
            },
            tarihChange(val, mod) {
                if (mod === 'cerrahi') {
                    this.dateCerrahi = functions.dateconvert(val)
                } else this.dateRandevu = functions.dateconvert(val)
            },
            urunAdi(val) {
                var obj = this.urunList.find(data => data.urunId === val);
                return obj.baslik
            },
            ekUrunAdi(val) {
                var obj = this.ekUrunList.find(data => data.ekurunId === val);
                return obj.baslik
            },
            ekTedaviAdi(val) {
                var obj = this.ekTedaviList.find(data => data.ektedaviId === val);
                return obj.baslik
            },
            hekimAdii(val) {
                var obj = this.hekimList.find(data => data.hekimId === val);
                return obj.adSoyad
            },
            klinikName(val) {
                var obj = this.doktorlarKlinikList.find(data => data.klinikId === val);
                return obj.baslik
            },
            ilAdi(val) {
                var obj = this.ilList.find(data => data.ilId === val);
                return obj.baslik
            },
            kodGonder() {
                if (this.telefonNo !=='') {
                    kvkkService.kvkkKod(this.telefonNo).then((response) => {
                        if (response.status === 200) {
                            this.dogrulamaKoduTelefonVisible = false;
                            this.dogrulamaKoduVisible = true;
                        } else notification.Status(response.status, this)
                    })
                } else
                    notification.Status('warning', this, 'Telefon numarası giriniz');
            },
            dogrulamaKontrol() {
                if (this.dogrulamaKodu !=='') {
                    kvkkService.kvkkOnayTelefon(this.telefonNo, 0, this.dogrulamaKodu).then((response) => {
                        if (response.status === 200) {
                            this.dogrulamaKoduVisible = false;
                            this.hastaForm.telefon = this.telefonNo;
                        } else notification.Status(response.status, this)
                    })
                } else
                    notification.Status('warning', this, 'Doğrulama kodu giriniz');
            },
            dogrulamaDevamEt() {
                this.hastaForm.telefon = this.telefonNo;
                this.dogrulamaKoduTelefonVisible = false;
            },
            iptal() {
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "HastaTanimlama");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "HastaTanimlama") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
            hastaTanimlama() {
                var hekimList = [];
                this.hastaForm.doktor.forEach(function (e) {
                    hekimList.push(e.doktorId)
                });
                hastaService.hastaKaydi(hekimList, this.hastaForm.klinik, this.hastaForm.tcNo, this.hastaForm.adSoyad, this.hastaForm.yas, this.hastaForm.cinsiyet,
                    this.hastaForm.eposta, this.hastaForm.telefon, this.hastaForm.il, this.hastaForm.cerrahiTarih, this.hastaForm.cerrahiUygList,
                    this.hastaForm.randevuHekim, this.hastaForm.randevuTarihi, this.hastaForm.randevuList).then((response) => {
                    if (response.status === 200) {
                        this.$refs['hastaForm'].resetFields();
                        this.active = 4;

                        this.telefonNo = '';
                        this.dogrulamaKodu = ''
                        this.disId = ''
                        this.disIdRan = ''
                        this.eskiDisId = ''
                        this.urunId = ''
                        this.urunLot = ''
                        this.ekUrunId = ''
                        this.ekUrunIdRan = ''
                        this.ekUrunLot = ''
                        this.ekUrunLotRan = ''
                        this.ekTedaviId = ''
                        this.ekTedaviIdRan = ''
                        this.isq = ''
                        this.isqRan = ''
                        this.aciklamaRan = ''
                        this.rightDisable = true
                        this.rightDisableRan = true

                        this.dogrulamaKoduTelefonVisible = true;
                        this.dogrulamaKoduVisible = false;
                        this.klinikDialogVisible = false;
                        this.dateCerrahi = '';
                        this.dateRandevu = '';
                        this.secilenDis = '';
                        this.dialogVisibleHekim = false;

                        // klinikList: [],
                        this.cerrahiUygList = [{
                            disId: '',
                            urunId: '',
                            urunLot: '',
                            ekUrunId: '',
                            ekUrunLot: '',
                            isq: '',
                            ekTedaviId: '',
                        }]

                        this.hastaForm = {
                            tcNo: '',
                            adSoyad: '',
                            yas: '',
                            cinsiyet: '',
                            telefon: '',
                            eposta: '',
                            il: '',
                            randevuHekim: '',

                            doktor: [{
                                doktorId: '',
                                doktorTelefon: '',
                                doktorEposta: '',
                            }],
                            klinik: '',

                            cerrahiTarih: '',
                            cerrahiUygList: [],


                            randevuTarihi: '',
                            randevuList: [],

                        }
                        EventBus.$emit("hastaList", true)
                        notification.Status('success', this, 'Hasta kaydı başarıyla oluşturuldu.');
                        setTimeout(() => this.active = 0, 1500);
                        this.hastaId = response.data.hastaId;
                    } else notification.Status(response.status, this)
                })
            },
            getHekimlerKlinikListesi(gelenListe) {
                hekimService.hekimlerKlinikListesi(gelenListe).then((response) => {
                    if (response.status === 200) {
                        this.doktorlarKlinikList = response.data;
                    } else notification.Status(response.status, this)
                })
                this.klinikDialogVisible = true
            },
            klinikSecmeModal() {
                var klinikHekimList = [];
                this.hastaForm.doktor.forEach(function (e) {
                    klinikHekimList.push(e.doktorId);
                });
                this.getHekimlerKlinikListesi(klinikHekimList)
            },
            getIl() {
                ilService.il().then((response) => {
                    if (response.status === 200) {
                        this.ilList = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            getIlYonetici() {
                var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
                yoneticiService.yonetimIlList(userData3H["yonetimKodu"]).then((response) => {
                    if (response.status === 200) {
                        this.ilList = response.data;
                    }
                })

            },
            getUrunList() {
                cerrahiService.urunListesi(1, '', '').then((response) => {
                    if (response.status === 200) {
                        this.urunList = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            getEkUrunList() {
                cerrahiService.ekUrunListesi(1, '', '').then((response) => {
                    if (response.status === 200) {
                        this.ekUrunList = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            getEkTedaviList() {
                cerrahiService.ekTedaviListesi(1, '', '').then((response) => {
                    if (response.status === 200) {
                        this.ekTedaviList = response.data;
                        this.ekTedaviListKlon = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            getHekimList() {
                let self = this;
                hekimService.hekimList(1, '', '').then((response) => {
                    if (response.status === 200) {

                        response.data.forEach(function (e) {
                            var obj = self.hekimList.find(data => data.hekimId === e.hekimId);
                            if (obj === undefined) {
                                self.hekimList.push(e)
                            }
                        });
                        this.hekimList = response.data;


                    } else notification.Status(response.status, this)
                })

            },
            inputStyle(val) {
                var splitStr = val.toLowerCase().split(' ');
                for (var i = 0; i < splitStr.length; i++) {
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
                this.hastaForm.adSoyad = splitStr.join(' ');
            },
            next() {
                this.$refs.hastaForm.validate((valid) => {
                    if (valid) {
                        if (this.active === 0) {
                            this.klinikSecmeModal()
                        }
                        if (this.active++ > 4) ;
                    }
                })
                if (this.active === 4) {
                    setTimeout(() => this.active = 0, 3000);
                }
            },
            back() {
                if (this.active-- > 0) ;
            },

            doktorEkle() {
                // this.$refs.hastaForm.validate((valid) => {
                //     if (valid) {
                this.hastaForm.doktor.push({
                    doktorId: '',
                    doktorTelefon: '',
                    doktorEposta: '',
                    klinik: '',
                });
                // }
                // })

            },
            removedoktor(item) {
                this.hastaForm.doktor.splice(item, 1);
            },
            doktorTespit(val, gelenIndex) {
                var obj = this.hekimList.find(data => data.hekimId === val);
                if (obj !== undefined) {
                    this.hastaForm.doktor[gelenIndex].doktorTelefon = obj.telefon;
                    this.hastaForm.doktor[gelenIndex].doktorEposta = obj.eposta;
                    // this.hastaForm.doktor[gelenIndex].klinik = obj.klinik.length > 0 ? obj.klinik[0].klinikId : " ";
                    // this.klinikList = obj.klinik;
                }
            },
            disabledDate(time) {
                return time.getTime() < Date.now() - 8.64e7
            }
        }
    }
</script>

<style scoped>
    .deleteButton {
        position: absolute;
        right: 5px;
        top: 0;
        z-index: 10;
        padding: 5px;
        border-radius: 0 0 0 5px;
    }

    .addButton {
        position: absolute;
        right: 5px;
        bottom: 0;
        z-index: 10;
        padding: 5px;
        border-radius: 5px 0 0 0;
    }

    .esnek-kutu {
        display: flex;
        justify-content: center;
    }

    .ileriButton {
        margin-right: 3px;
        box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065)
    }

    .geriButton {
        margin-left: 3px;
        box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065)
    }

    .siraNo {
        position: absolute;
        background: #9a9a9a;
        top: -5px;
        left: 0;
        border-radius: 0px 5px 5px 0px;
        padding: 5px 10px;
        color: #fff;
        font-weight: bold;
    }


    #agizGorunumu {
        position: relative;
        z-index: 100;
        margin: auto;
        display: block
    }

    #agizGorunumu path {
        cursor: pointer;
        position: relative;
        z-index: 50
    }

    /*#agizGorunumu path:hover {*/
    /*fill: #00cbc0!important*/
    /*}*/

    #agizGorunumu path[data-aktifdis=aktifDis],
    .seciliDis {
        fill: #00cbc0 !important
    }


    #agizGorunumu path[data-index=zIndexPath] {
        position: relative;
        z-index: 100;

    }

    #agizGorunumu path[data-index=zIndexPath]:hover {
        fill: #00cbc0 !important

    }

    .hastaKabulBaslik {
        display: flex;
        justify-content: center;
        align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
    }

    .hastaKabulBaslik h1 {
        background: #161c3c;
        color: #fff;
        font-weight: 700;
        padding: 8px 20px;
        position: relative;
    }

    .hastaKabulFormu {
        position: relative;
        z-index: 10;
    }

    .formBilgileri {
        display: flex;
    }

    .ozel-sagayasla {
        float: right;
    }

    .formBilgiBaslik {
        writing-mode: tb-rl;
        transform: rotate(180deg);
        float: left;
        text-align: center;
        background: #161c3c;
        color: #fff;
        padding: 12px 2px;
        text-transform: uppercase;
        font-weight: 600;
        position: relative;
        min-height: 190px;
    }

    .mobil-baslik {
        display: none;
        text-align: center;
        background: #161c3c;
        padding: 5px 2px;
        text-transform: uppercase;
        font-weight: 600;
        width: 100%;
        color: #fff;
    }

    .formElemanlari {
        padding: 0 20px !important;
    }

    .input-effect {
        position: relative;
        display: flex;
        align-items: flex-start;
    }

    .input-effect .formBilgi {
        height: 100%;
        padding: 10px 10px 0;
        font-size: 14px;
        font-weight: 500;
        flex-shrink: 0;
        min-width: 90px;
    }


    .yazdir-bilgisi {
        font-size: 14px;
        padding: 5px;
    }

    .effect-7, .effect-8, .effect-9 {
        border: 1px solid transparent;
        padding: 10px 10px 0;
        transition: .4s;
        width: 100%;
    }

    .formBilgiBaslik.sagTaraf {
        transform: none;
    }

    .formBilgiBaslik:before {
        content: "";
        position: absolute;
        top: 50%;
        right: 27px;
        transform: translate(0, -50%);
        display: inline-block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 10px 10px 0;
        border-color: transparent #161c3c transparent transparent;
    }

    .grupBilgisi {
        background: linear-gradient(90deg, rgba(22, 28, 60, 0) 5%, rgba(22, 28, 60, 0.5) 25%, rgba(22, 28, 60, 1) 40%, rgba(22, 28, 60, 1) 60%, rgba(22, 28, 60, 0.5) 75%, rgba(22, 28, 60, 0) 95%);
        font-size: 14px;
        font-weight: 500;
        padding: 8px 6px;
        text-align: center;
    }

    .grupBilgisi p {
        margin: 0;
        color: #fff;
    }

    .disOpsiyonlari {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        width: 100%;
        padding-top: 10px;
        page-break-inside: avoid;
        justify-content: start;
    }

    .yazdirFormSayfa .disNumarasi-yazdir {
        border-bottom: 1px solid #eee;
    }

    .randevular .opsiyonDiv {
        padding: 6px 5px;
        width: 18%;
        margin: 4px 0;
        text-align: center;
        font-size: 14px;
        position: relative;
        /*border-bottom: 1px solid #ddd;*/
    }

    .opsiyonDiv {
        padding: 6px 5px;
        width: 11%;
        margin: 4px 0;
        text-align: center;
        font-size: 14px;
        position: relative;
        /*border-bottom: 1px solid #ddd;*/
    }


    .doktor-bilgi {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }


    .opsiyonDiv:before {
        content: "";
        position: absolute;
        width: 2px;
        height: 100%;
        right: 0;
        top: 0;
        background: #3cbcb4;
        background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(#3cbcb4), to(transparent));
        background: linear-gradient(transparent, #3cbcb4, transparent);
    }

    .opsiyonDiv:nth-child(1):after {
        content: "";
        position: absolute;
        width: 2px;
        height: 100%;
        left: 0;
        top: 0;
        background: #3cbcb4;
        background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(#3cbcb4), to(transparent));
        background: linear-gradient(transparent, #3cbcb4, transparent);
    }

    .disler-arasi-cizgi {
        height: 2px;
        width: 95%;
        position: relative;
        left: 50%;
        transform: translateX(calc(-50% + -27px));
        margin: 8px 0;
        background: linear-gradient(transparent, #3cbcb4, transparent);
    }

    .disNumarasi-yazdir div:first-child {
        color: #3cbcb4;
        text-transform: uppercase;
    }

    .opsiyonDiv div:first-child {
        font-weight: 600;
        color: #444;
        margin-bottom: 5px;
    }

    .disNumarasi-yazdir div:last-child {
        font-weight: 700;
    }

    .disNumarasi-yazdir div:last-child span {
        padding: 3px 7px;
        border: 1px solid #00bcb4;
        color: #0a716b;
        display: inline-block;
    }


    .opsiyonDiv div:first-child {
        font-weight: 600;
        color: #444;
        margin-bottom: 5px;
    }

    .ozel-row {
        display: flex;
        justify-content: center;
    }

    @media only screen and (max-width: 480px) {
        .opsiyonDiv:nth-child(1):after,
        .opsiyonDiv:nth-child(3):after,
        .opsiyonDiv:nth-child(5):after,
        .opsiyonDiv:nth-child(7):after {
            content: "";
            position: absolute;
            width: 2px;
            height: 100%;
            left: 0;
            top: 0;
            background: #3cbcb4;
            background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(#3cbcb4), to(transparent));
            background: linear-gradient(transparent, #3cbcb4, transparent);
        }

        .opsiyonDiv {
            width: 45%;
        }

        .ozel-row {
            display: block;
        }

        .input-effect .formBilgi {
            padding: 5px;
            min-width: 60px;
        }

        .formBilgiBaslik {
            display: none;
        }

        .formBilgiBaslik:before {
            display: none;
        }

        .ozel-sagayasla {
            float: none;
        }

        .formElemanlari {
            padding: 0 !important;
        }

        .mobil-baslik {
            display: block;
        }

        .formBilgileri {
            display: block;
        }

        .doktor-bilgi {
            position: static;
            transform: none;
        }
    }

    @media only screen and (max-width: 768px) {
        .opsiyonDiv {
            width: 45%;
        }

        .ozel-row {
            display: block;
        }

        .input-effect .formBilgi {
            padding: 5px;
            min-width: 86px;
        }

        .formBilgiBaslik {
            display: none;
        }

        .formBilgiBaslik:before {
            display: none;
        }

        .ozel-sagayasla {
            float: none;
        }

        .formElemanlari {
            padding: 0 !important;
        }

        .mobil-baslik {
            display: block;
        }

        .formBilgileri {
            display: block;
        }

        .doktor-bilgi {
            position: static;
            transform: none;
        }
    }

</style>
<style lang="scss">
    .seciliDis {
        fill: #00cbc0 !important
    }

    .deaktifDis {
        opacity: .3;
        //pointer-events:none;
    }

    .seciliDis.deaktifDis {
        opacity: 1;
    }

    .klinikModal .el-dialog__close {
        display: none;
    }
</style>